import  { FunctionComponent, SyntheticEvent } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { useTranslation } from 'react-i18next';
import {
  useMode,
  useItemsLeft,
  useUpgradeAmount,
  useIdsItemsLeft,
} from './hooks';

import IconUpgrade1 from '../../scss/images/icon-upgrade-1.svg';
import IconUpgrade1Hover from '../../scss/images/icon-upgrade-1-hover.svg';
import IconUpgrade2 from '../../scss/images/icon-upgrade-2.svg';
import IconUpgrade2Hover from '../../scss/images/icon-upgrade-2-hover.svg';

import { useProfile } from '../profile/hooks';

const UpgradeBtns: FunctionComponent = () => {
  const { t } = useTranslation();
  const [, setItemsLeft] = useItemsLeft();
  const [, setUpgradeAmount] = useUpgradeAmount();
  const [, setIdsItemsLeft] = useIdsItemsLeft();
  const [mode, setMode] = useMode();
  const getProfile = useProfile();

  const onChangeMode = (event: SyntheticEvent<HTMLElement>) => {
    event.preventDefault();

    const targetMode = Number(event.currentTarget.dataset.type);

    if (mode !== targetMode) {
      setItemsLeft([]);
      setUpgradeAmount(0);
      setIdsItemsLeft([]);
    }

    setMode(targetMode);
  };

  return (
    <div className="upgrade-main-btns">
      <a
        className={mode === 0 ? 'active' : ''}
        href="#"
        onClick={onChangeMode}
        data-type={0}
      >
        <div className="icon">
          <LazyLoadImage src={IconUpgrade2} alt="" />
          <LazyLoadImage className="hover" src={IconUpgrade2Hover} alt="" />
        </div>
        <span className="text">
          {t('skins')}
        </span>
      </a>
      <a
        className={`take-money ${!getProfile && 'disabled'} ${
          mode === 1 && 'active'
        }`}
        href="#"
        onClick={onChangeMode}
        data-type={1}
      >
        <div className="icon material-icons" data-icon="payments" />
        <span className="text">
          {t('balance')}
        </span>
      </a>
    </div>
  );
};

export default UpgradeBtns;
